import { render, staticRenderFns } from "./AdminParams.vue?vue&type=template&id=7a0a2d0c"
import script from "./AdminParams.vue?vue&type=script&lang=js"
export * from "./AdminParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports